import { callApi } from "./callApi";
import { ls } from "./storage";

export const initBaseLanguageInterval = () => {
  if (window.setBaseLanguageInterval != true) {
    const interval = () => {
      callApi("/api/system/language/base/getActiveLanguage", "GET", {}).then(
        res => {
          if (res.activeLanguageIds && res.activeLanguageIds.length > 0) {
            window.localStorage["activeLanguageIds"] = JSON.stringify(
              res.activeLanguageIds
            );
          }
        }
      );
    };
    window.setInterval(interval, 60000);
    window.setBaseLanguageInterval = true;
    interval();
  }
};

export const checkLang = () => {
  if (
    ls.getJSONObj("activeLanguageIds") &&
    ls.getJSONObj("activeLanguageIds").length > 1
  ) {
    callApi("/api/system/language/base/getLang", "GET", {}).then(res => {
      if (
        res.status != false &&
        res.lang &&
        res.lang != localStorage["languageidweaver"]
      ) {
        localStorage["languageidweaver"] = res.lang;
        localStorage["e9_locale"] = "";
        localStorage["isInitLSValue"] = false;
        window.location.reload();
      }
    });
  }
};

export const initRefreshLanguageInterval = () => {
  const interval = () => {
    if (
      ls.getJSONObj("activeLanguageIds") &&
      ls.getJSONObj("activeLanguageIds").length > 1
    ) {
      callApi("/api/system/language/base/getLang", "GET", {}).then(res => {
        if (
          res.status != false &&
          res.lang &&
          res.lang != localStorage["languageidweaver"]
        ) {
          localStorage["languageidweaver"] = res.lang;
          localStorage["e9_locale"] = "";
          localStorage["isInitLSValue"] = false;
          window.location.reload();
        }
      });
    }
  };
  window.setInterval(interval, 30000);
  interval();
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/baseLanguageInterval.js